import { useEffect, useState } from 'react';
import { safeJson, networkMessage } from '../apiHelpers';
import { t } from '../i18n';

const API = '/api/reviews';
function authHeaders(tokenOverride) {
  const token = tokenOverride || localStorage.getItem('token');
  return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Token ${token}` } : {}) };
}
const C = { border: '#E3E1D9', text: '#2C2C2A', muted: '#5F5E5A', primary: '#0F6E56', star: '#EF9F27' };

function Stars({ value, onSet, size = 18 }) {
  return (
    <span style={{ display: 'inline-flex', gap: 2 }}>
      {[1, 2, 3, 4, 5].map((n) => (
        <span key={n} onClick={onSet ? () => onSet(n) : undefined}
          style={{ fontSize: size, cursor: onSet ? 'pointer' : 'default', color: n <= value ? C.star : '#D3D1C7', lineHeight: 1 }}>★</span>
      ))}
    </span>
  );
}

// Verified badge — kisi bhi jagah dikhane ke liye
export function VerifiedBadge({ module, objectId }) {
  const [v, setV] = useState(false);
  useEffect(() => {
    fetch(`${API}/${module}/${objectId}/verified/`).then((r) => r.json()).then((d) => setV(!!d.verified)).catch(() => {});
  }, [module, objectId]);
  if (!v) return null;
  return <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: 12, fontWeight: 600, color: C.primary, background: '#E1F5EE', padding: '2px 8px', borderRadius: 10 }}>✓ {t('rv_verified')}</span>;
}

export default function ReviewBox({ module, objectId, objectTitle = '', isAdmin = false, token = null, loggedIn = null }) {
  const [data, setData] = useState(null);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [msg, setMsg] = useState('');

  const load = () => fetch(`${API}/${module}/${objectId}/`, { headers: authHeaders(token) }).then((r) => r.json()).then((d) => {
    setData(d);
    if (d.my_review) { setRating(d.my_review.rating); setComment(d.my_review.comment); }
  });
  useEffect(() => { load(); }, [module, objectId]); // eslint-disable-line

  const submit = async () => {
    if (rating < 1) { setMsg(t('rv_select_rating')); return; }
    const res = await fetch(`${API}/${module}/${objectId}/submit/`, { method: 'POST', headers: authHeaders(token), body: JSON.stringify({ rating, comment, object_title: objectTitle }) });
    const d = await safeJson(res);
    setMsg(d.success ? '✅ ' + t('rv_thanks') : (d.error || t('rv_failed')));
    if (d.success) load();
  };

  const toggleVerify = async () => {
    const res = await fetch(`${API}/${module}/${objectId}/verify/`, { method: 'POST', headers: authHeaders(token), body: JSON.stringify({ verified: !data.verified, object_title: objectTitle }) });
    const d = await safeJson(res);
    if (d.success) load();
  };

  if (!data) return <p style={{ fontSize: 13, color: C.muted }}>{t('rv_loading')}</p>;

  return (
    <div style={{ borderTop: `0.5px solid ${C.border}`, paddingTop: 14, marginTop: 14 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10, flexWrap: 'wrap' }}>
        <Stars value={Math.round(data.avg_rating)} />
        <span style={{ fontSize: 14, fontWeight: 600 }}>{data.avg_rating}</span>
        <span style={{ fontSize: 13, color: C.muted }}>({data.count} {data.count !== 1 ? t('rv_reviews') : t('rv_review')})</span>
        {data.verified && <span style={{ fontSize: 12, fontWeight: 600, color: C.primary, background: '#E1F5EE', padding: '2px 8px', borderRadius: 10 }}>✓ {t('rv_verified')}</span>}
        {isAdmin && <button onClick={toggleVerify} style={{ fontSize: 11, padding: '3px 10px', border: `0.5px solid ${C.border}`, borderRadius: 6, background: '#fff', cursor: 'pointer', marginLeft: 'auto' }}>{data.verified ? t('rv_remove_verify') : '✓ ' + t('rv_mark_verified')}</button>}
      </div>

      {(loggedIn !== null ? loggedIn : localStorage.getItem('token')) && (
        <div style={{ background: '#F7F5F0', borderRadius: 8, padding: '0.7rem 0.85rem', marginBottom: 12 }}>
          <p style={{ fontSize: 12, color: C.muted, margin: '0 0 6px' }}>{data.my_review ? t('rv_update_review') : t('rv_leave_review')}</p>
          <Stars value={rating} onSet={setRating} size={22} />
          <textarea value={comment} onChange={(e) => setComment(e.target.value)} placeholder={t("rv_your_experience")}
            style={{ width: '100%', marginTop: 8, padding: '7px 9px', fontSize: 13, border: `0.5px solid ${C.border}`, borderRadius: 6, boxSizing: 'border-box', minHeight: 44 }} />
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 6 }}>
            <button onClick={submit} style={{ fontSize: 13, fontWeight: 600, padding: '6px 14px', border: 'none', borderRadius: 8, background: C.primary, color: '#fff', cursor: 'pointer' }}>{t('rv_submit')}</button>
            {msg && <span style={{ fontSize: 12, color: C.primary }}>{msg}</span>}
          </div>
        </div>
      )}

      {data.reviews.map((r, i) => (
        <div key={i} style={{ padding: '8px 0', borderTop: i > 0 ? `0.5px solid ${C.border}` : 'none' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: 13, fontWeight: 600 }}>@{r.reviewer}</span>
            <Stars value={r.rating} size={13} />
          </div>
          {r.comment && <p style={{ fontSize: 13, color: C.text, margin: '3px 0 0' }}>{r.comment}</p>}
          <p style={{ fontSize: 11, color: C.muted, margin: '2px 0 0' }}>{r.date}</p>
        </div>
      ))}
    </div>
  );
}
